import auth from './features/auth/authSilice';
import { configureStore } from '@reduxjs/toolkit'
export default configureStore({
    reducer: {
      auth,
    }
  })